import "./app/root.css";
import { createRoot } from "react-dom/client";
import {
  RouterProvider,
  createRouter,
  defaultStringifySearch,
  defaultParseSearch,
} from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";
import { TRPCProvider } from "./utils/trpc.client";
import { registerStaleBundleRecovery } from "./utils/staleBundle";

registerStaleBundleRecovery();

// Keep `/` literal in search values (e.g. ?redirect=/me) instead of %2F-encoding,
// matching the URL shape the old Next middleware produced.
const stringifySearch = (search: Record<string, unknown>) =>
  defaultStringifySearch(search).replace(/%2F/gi, "/");

const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  scrollRestoration: true,
  parseSearch: defaultParseSearch,
  stringifySearch,
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const rootEl = document.getElementById("root");
if (!rootEl) throw new Error("Root element #root not found");

createRoot(rootEl).render(
  <TRPCProvider>
    <RouterProvider router={router} />
  </TRPCProvider>,
);
